var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Song } from '@ddradar/core';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getSongInfo, shortenSeriesName } from '~/api/song';
import ScoreEditor from '~/components/modal/ScoreEditor.vue';
let ChartListComponent = class ChartListComponent extends Vue {
    get displayedCharts() {
        const getLowerDiffName = (d) => Song.difficultyMap.get(d).toLowerCase();
        return this.charts.map(c => ({
            series: shortenSeriesName(c.series),
            name: c.name,
            link: `/songs/${c.id}#${c.playStyle}${c.difficulty}`,
            difficultyName: Song.difficultyMap.get(c.difficulty),
            class: `is-${getLowerDiffName(c.difficulty)}`,
            level: c.level,
            id: c.id,
            playStyle: c.playStyle,
            difficulty: c.difficulty,
        }));
    }
    async scoreEditorModal(songId, playStyle, difficulty) {
        const songData = await getSongInfo(this.$http, songId);
        this.$buefy.modal.open({
            parent: this,
            component: ScoreEditor,
            props: { songId, playStyle, difficulty, songData },
            hasModalCard: true,
            trapFocus: true,
        });
    }
};
__decorate([
    Prop({ required: false, type: Array, default: () => [] })
], ChartListComponent.prototype, "charts", void 0);
__decorate([
    Prop({ required: false, type: Boolean, default: false })
], ChartListComponent.prototype, "loading", void 0);
ChartListComponent = __decorate([
    Component
], ChartListComponent);
export default ChartListComponent;
